import defineService from './defineService';
const getLibraryList = defineService('get', 'spool/libraries/', {mainKey: 'results'});
const getLibrary = defineService('get', 'spool/libraries/:id/');
const postLibrary = defineService('post', 'spool/libraries/');
const deleteLibrary = defineService('delete', 'spool/libraries/:id/');
const postLibraryTemplate = defineService('post', 'spool/libraries/:id/templates/:template/');
const deleteLibraryTemplate = defineService('delete', 'spool/libraries/:id/templates/:template/');

export function libraries() {
  return getLibraryList();
}

export function createLibrary({name}) {
  // Return newly create library
  return postLibrary({name});
}

export function removeLibrary(id) {
  return deleteLibrary(id);
}

export function library(library_id) {
  return getLibrary(library_id);
}

export function addTemplateToLibrary(library_id, template_id) {
  return postLibraryTemplate(library_id, template_id, {});
}

export function removeTemplateFromLibrary(library_id, template_id) {
  return deleteLibraryTemplate(library_id, template_id);
}



// WEBPACK FOOTER //
// ./src/services/libraries.js